import React from "react";
import Button from "@/components/buttons/button";
import BaseDialog, {BaseDialogProps} from "@/components/dialogs/base-dialog";

export interface PromptDialogProps extends BaseDialogProps {
    onConfirm: () => void;
    
    confirmLabel?: string;
    cancelLabel?: string;
}

const PromptDialog: React.FC<PromptDialogProps> = ({ open, onConfirm, onClose, title, children, confirmLabel = 'Valider', cancelLabel = 'Annuler' }) => (
    <BaseDialog open={open} onClose={onClose} title={title}>
        <div className='flex flex-col gap-y-4'>
            {children}
            
            <div className='flex flex-row gap-x-2 ml-auto'>
                <Button onClick={() => onClose(true)} type='button' variant='ghost'>
                    {cancelLabel}
                </Button>

                <Button onClick={onConfirm} type='button' variant='primary'>
                    {confirmLabel}
                </Button>
            </div>
        </div>
    </BaseDialog>
);

export default PromptDialog;